import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=2dbba9f3&"
import script from "./BaseInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports